import { render, staticRenderFns } from "./PaperSave.vue?vue&type=template&id=7b1fcf71&scoped=true"
import script from "./PaperSave.vue?vue&type=script&lang=js"
export * from "./PaperSave.vue?vue&type=script&lang=js"
import style0 from "./PaperSave.vue?vue&type=style&index=0&id=7b1fcf71&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b1fcf71",
  null
  
)

export default component.exports